import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconGiftCard = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconGiftCard",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M160-280v80h640v-80zm0-440h88q-5-9-6-19t-2-21q0-50 35-85t85-35q30 0 56 16t44 38l20 26 20-26q18-24 44-39t56-15q50 0 85 35t35 85l-1 21q-1 10-7 19h88q33 0 57 24t23 56v440q0 33-23 57t-57 23H160q-33 0-56-23t-24-57v-440q0-33 24-56t56-24m0 320h640v-240H596l60 82q10 14 8 30t-16 25-29 8-26-16L480-664 367-511q-10 13-25 16t-30-8-16-25 7-30l59-82H160zm200-320q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m240 0q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11"
  })
}));
IconGiftCard.displayName = 'IconGiftCard';